import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AuthService } from './auth.service';

@Component({
  selector: 'zlo-backoffice-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouterLink],
  template: `
    @if (auth.isAuthenticated()) {
    <nav>
      <div class="nav-inner">
        <a routerLink="/organizations" class="brand">Zelo Backoffice</a>
        <a routerLink="/flags">Flags</a>
        <a routerLink="/access-keys">Access keys</a>
        <a routerLink="/audit">Audit log</a>
        <a routerLink="/cron-jobs">Cron jobs</a>
        <span class="spacer"></span>
        <span class="who">
          {{ auth.staff()?.email }}
          <span class="role">{{ auth.staff()?.role }}</span>
        </span>
        <button type="button" class="link" (click)="auth.logout()">
          Sign out
        </button>
      </div>
    </nav>
    }

    <div class="page">
      <router-outlet />
    </div>
  `,
  styles: `
    /* Full-bleed so the bottom border spans the window, while .nav-inner
       carries the same max-width as .page — otherwise the brand sits hard
       against the left edge while the content it labels is centred. */
    nav {
      border-bottom: 1px solid var(--border);
    }
    /* Padding sits on .nav-inner, not on nav. Both this and .page are
       border-box, so their max-width includes their padding — putting the
       padding on the outer nav instead would make this box 2 * --page-pad
       wider than .page and leave the brand hanging left of the content it
       labels. */
    .nav-inner {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;
      max-width: var(--page-max);
      margin: 0 auto;
      padding: 0.75rem var(--page-pad);
    }
    .brand {
      font-weight: 600;
    }
    .spacer {
      flex: 1;
    }
    .who {
      color: var(--muted);
      font-size: 0.875rem;
      /* An email is one unbroken token; without this it forces the nav wider
         than the window on a narrow viewport. */
      overflow-wrap: anywhere;
    }
    .role {
      border: 1px solid var(--border);
      border-radius: 3px;
      padding: 0.05rem 0.35rem;
      margin-left: 0.35rem;
      font-size: 0.75rem;
    }
    /* margin: 0 auto is the actual centring — max-width alone just caps the
       width and leaves the content pinned to the left on a wide screen. */
    .page {
      padding: var(--page-pad);
      max-width: var(--page-max);
      margin: 0 auto;
    }
  `
})
export class AppComponent {
  readonly auth = inject(AuthService);
}
